import Box from '@mui/material/Box';
import GifImage from '../images/loadingFullScreen.gif';

const Loader = () => {
    return(
        <div className ="loadingFullScreen fadeIn animated" style={{justifyContent:'center', alignItems: 'center'}}>
			<Box component='img' alt='gif-loader'  src={GifImage} />
	    </div>
    );
}
export default Loader;
